<script lang="ts">
	import {
		hoverState,
		hoveredXpos,
		hoveredYpos,
		originHoveredXpos,
		originHoveredYpos
	} from '../../stores/hover';
	import type { Collection, Element, GameArray } from '../utils/types';

	import { gameStart, winner } from '../../stores/winState';
	import { fade, fly } from 'svelte/transition';
	import { afterUpdate, onMount } from 'svelte';
	import { tweened } from 'svelte/motion';
	import { COLS, ROWS, SymType } from '../../stores/settingsStore';
	import { CIRCLE_DIAMETER } from '../../utils/constants';
	import { LightenDarkenColor } from '../../utils/colors';
	import { transitionToActive } from '../../stores/gameState';
	import { element } from 'svelte/internal';

	export let x = 0;
	export let y = 0;

	//export let winState: () => void = null;
	export let onmouseover: (index1: number, index2: number, x: number, y: number) => void;
	export let changeVariantElement: () => void;

	//export let addVariantElement: (xpos: number, ypos: number) => void = null;
	//export let removeVariantElement: (xpos: number, ypos: number) => void = null;

	$: mouseOut = false;
	onMount(() =>
		setTimeout(() => {
			$transitionToActive = true;
		}, 2000)
	);

	function fadeScale(node, { delay = 0, duration = 400, baseScale = 0 }) {
		const o = +getComputedStyle(node).opacity;
		const m = getComputedStyle(node).transform.match(/rotateY\(([0-9.]+)\)/);
		const s = (m ? m[1] : 1) as number;

		return {
			delay,
			duration,
			css: (t) => `opacity: ${t * o}; transform:rotateY(${t * s})`
		};
	}
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->

<div
	class="item-wrapper {$winner && 'blinker'}"
	style="
    top:{y >= 5 && $SymType === 'Horizontal' ? y * 50 + 2 : y * 50}px; 
    left:{x >= 3 && $SymType === 'Vertical' ? x * 50 + 2 : x * 50}px;
	animation-duration: {Math.random()}s
	"
	on:mouseout={() => {
		//	if (!$hoverState) {
		//	winState();
		//	}
	}}
	on:mouseover={() => {
		if ($hoverState) {
			//console.log('continue');
			onmouseover(x, y, $hoveredXpos, $hoveredYpos);
			//$tweenLeft = $hoveredXpos;
			$hoveredXpos = x;
			$hoveredYpos = y;
			changeVariantElement();

			//addVariantElement(x, y);
		}
	}}
>
	<div
		in:fade={{ delay: 1800 * (x / 100 + y / 100) }}
		class="item"
		style="background-color:#202020	;"
	>
		<!-- duplicate div .. TODO create a seperate compoent for it  -->
		<div
			class="symmetrical-item"
			style="left:{50 / 2 - CIRCLE_DIAMETER / 2}px;
        width:{CIRCLE_DIAMETER}px;
        height:{CIRCLE_DIAMETER}px;
        top:{50 / 2 - CIRCLE_DIAMETER / 2}px;
        z-index:100;
        "
		/>
	</div>
</div>

<style>
	.item-wrapper {
		position: absolute;
		width: 50px;
		height: 50px;
		perspective: 1200px;
		transform-style: preserve-3d;
	}

	.symmetrical-item {
		user-select: none;
		box-sizing: border-box;
		position: absolute;
		top: 25px;
		width: 20px;
		height: 20px;
		border-radius: 10px;
		background-color: transparent;
		/* border: solid #1f1f1f 3px; */
		z-index: 3;
	}

	.item {
		user-select: none;
		box-sizing: border-box;
		position: absolute;
		width: 50px;
		height: 50px;
		border: 1px solid rgba(135, 206, 250, 0.26);
		z-index: 2;

		animation-duration: 1200ms;
		animation-fill-mode: forwards;
		animation-name: flip;
		transform-style: preserve-3d;
	}

	@keyframes flip {
		from {
			opacity: 0;
			transform: rotateX(1deg);
		}
		to {
			opacity: 1;
			transform: rotateX(180deg);
		}
	}
	.blinker {
		animation-name: blink;
		animation-duration: 1s;
		animation-iteration-count: infinite;
		animation-fill-mode: both;
		animation-timing-function: linear;
	}
	@keyframes blink {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
</style>
